export default __webpack_public_path__ + "static/media/icon-alert.da69eb5b.svg";